import typeCheckUtils from '../../utils/typeCheckUtils';

import { TYPES_MAP_VALUES } from '../../constants/ListingCriteriaConstants';

import Criterion from './Criterion';

import type { CriterionProps } from './Criterion';

const getDefaultCriteriaList = () => TYPES_MAP_VALUES.map((typeValue) => Criterion({ type: typeValue }));

/**
 * returns array of `Criterion` in order as appeared in `TYPES_MAP_VALUES`
 */
const getCriteriaList = ({ criteria = [] }: { criteria?: Array<Partial<CriterionProps>> }): Array<CriterionProps> => {
  const res = criteria.map((criterion) => Criterion(criterion));

  const uniqueMap: Record<string, unknown> = {};

  for (const criterion of getDefaultCriteriaList().concat(res)) {
    uniqueMap[criterion.type] = criterion;
  }

  return Object.values(uniqueMap) as Array<CriterionProps>;
};

export type ListingCriteriaProps = {
  isEnabled: boolean | null;
  criteria: Array<CriterionProps>;
};

export type ListingCriteriaInput = {
  isEnabled?: boolean | null;
  criteria?: Array<Partial<CriterionProps>>;
};

export type ScreeningCriteriaStatusProps = {
  isEnabled: boolean;
  isSet: boolean;
};

export const ScreeningCriteriaStatus = ({
  isEnabled = false,
  isSet = false,
}: Partial<ScreeningCriteriaStatusProps> = {}): ScreeningCriteriaStatusProps => ({
  isEnabled: Boolean(isEnabled),
  isSet: Boolean(isSet),
});

const ListingCriteria = ({ isEnabled = null, criteria = [] }: ListingCriteriaInput = {}): ListingCriteriaProps => ({
  isEnabled: typeCheckUtils.Boolean(isEnabled),
  criteria: getCriteriaList({ criteria }),
});

export default ListingCriteria;
